import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from "@angular/router";
import { TitleChange } from '../services/title-change';
import { Link } from "../directives/link";

@Component({
  selector: 'app-clement',
  imports: [RouterLink, Link],
  templateUrl: './clement.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './clement.scss',
})
export class Clement {
  dynamicTitle = inject(TitleChange);
  
  constructor() {
    this.dynamicTitle.title(`1 Clement`);
    this.dynamicTitle.description(`1 Clement does not provide any historical information about Jesus and is not considered a reliable source for his existence.`);
  }
}
